export default {
  caloriesColor: '',
};
